import {
  PaymentMethod,
  PaymentMethodCash,
  PaymentMethodCard,
  PaymentMethodMercadoPago,
  PaymentMethodMercadoPagoLink,
  PaymentMethodUalaLink,
  PaymentMethodZenriseLink,
  PaymentMethodDinelcoLink,
  PaymentMethodTransfer,
  PaymentMethodType,
} from './types';

export function isPaymentMethodCash(pm: PaymentMethod): pm is PaymentMethodCash {
  return pm.type === PaymentMethodType.CASH;
}

export function isPaymentMethodCard(pm: PaymentMethod): pm is PaymentMethodCard {
  return pm.type === PaymentMethodType.CARD;
}

export function isPaymentMethodMercadoPago(pm: PaymentMethod): pm is PaymentMethodMercadoPago {
  return pm.type === PaymentMethodType.MERCADOPAGO;
}

export function isPaymentMethodMercadoPagoLink(pm: PaymentMethod): pm is PaymentMethodMercadoPagoLink {
  return pm.type === PaymentMethodType.MERCADOPAGO_LINK;
}

export function isPaymentMethodUalaLink(pm: PaymentMethod): pm is PaymentMethodUalaLink {
  return pm.type === PaymentMethodType.UALA_LINK;
}

export function isPaymentMethodZenriseLink(pm: PaymentMethod): pm is PaymentMethodZenriseLink {
  return pm.type === PaymentMethodType.ZENRISE_LINK;
}

export function isPaymentMethodTransfer(pm: PaymentMethod): pm is PaymentMethodTransfer {
  return pm.type === PaymentMethodType.TRANSFER;
}

export function isPaymentMethodDinelcoLink(pm: PaymentMethod): pm is PaymentMethodDinelcoLink {
  return pm.type === PaymentMethodType.DINELCO_LINK;
}

/** Check if a payment method has a payment link feature */
export function isPaymentMethodWithLink(
  pm: PaymentMethod
): pm is PaymentMethodMercadoPagoLink | PaymentMethodUalaLink | PaymentMethodZenriseLink | PaymentMethodDinelcoLink {
  return (
    pm.type === PaymentMethodType.MERCADOPAGO_LINK ||
    pm.type === PaymentMethodType.UALA_LINK ||
    pm.type === PaymentMethodType.ZENRISE_LINK ||
    pm.type === PaymentMethodType.DINELCO_LINK
  );
}
